module.exports = __webpack_public_path__ + "static/ik-2-675e3afafae0858fc8dc58123fb98c6c.png";